import { render, staticRenderFns } from "./LoginKolegji.vue?vue&type=template&id=44135fa7&scoped=true"
import script from "./LoginKolegji.vue?vue&type=script&lang=js"
export * from "./LoginKolegji.vue?vue&type=script&lang=js"
import style0 from "./LoginKolegji.vue?vue&type=style&index=0&id=44135fa7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44135fa7",
  null
  
)

export default component.exports